import { AccountStatus, User } from '@/types/group';
import { RUserStatusV2, useUserByIdQueryRemote } from '@/store/v2';

export const useUser = (userId?: number): { user?: User; loading: boolean } => {
  const { data, loading } = useUserByIdQueryRemote({ variables: { userId: userId || 0 }, skip: !userId });

  const user = data?.user
    ? {
        id: data?.user?.id || 0,
        username: data?.user?.username || '',
        email: data?.user?.email || '',
        firstname: data?.user?.firstname || '',
        lastname: data?.user?.lastname || '',
        timestamp: new Date(data?.user?.timestamp || '').toISOString(),
        realm: data?.user?.realm || '',
        profileImage: data?.user?.profileImage,
        status: data?.user?.status as unknown as AccountStatus,
        lastActive: data?.user?.lastActive || new Date(),
        statusV2: data?.user?.statusV2 as unknown as RUserStatusV2,
        externalId: data?.user?.externalId || '',
      }
    : undefined;

  return { user, loading };
};
